import { gql } from '@apollo/client';

export const fetchLinkedSubscriptionsToBp = gql`
  query fetchLinkedSubscriptionsToBp(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        nodes {
          id
          logoId
          entitlementNumber
          productName
          productId
        }
      }
    }
  }
`;
